import React from 'react';
import BravoLoader from './BravoLoader';

class LoadingIcon extends React.Component
{
    static defaultProps = {
        loading: true,
        className: "h1"
    };

    render ()
    {
        return <BravoLoader loading={this.props.loading} variant="compact" className={this.props.className} />;
    }
}

export default LoadingIcon;
